export function chipStyle(remaining, yenilemeDurum) {
  if (yenilemeDurum === 'Yenilemeyecek' && remaining <= 4)
    return { bg: '#dc2626', text: '#fff', border: '#dc2626' }
  if (!yenilemeDurum && remaining <= 4)
    return { bg: '#facc15', text: '#000', border: '#eab308' }
  if (yenilemeDurum === 'Yenileyecek' && remaining <= 4)
    return { bg: '#f97316', text: '#fff', border: '#ea580c' }
  return { bg: '#3b82f6', text: '#fff', border: '#2563eb' }
}

export function chipSort(a, b) {
  var orderA = chipOrder(a.remaining, a.yenilemeDurum)
  var orderB = chipOrder(b.remaining, b.yenilemeDurum)
  return orderA - orderB
}

function chipOrder(remaining, yenilemeDurum) {
  if (yenilemeDurum === 'Yenilemeyecek' && remaining <= 4) return 1
  if (!yenilemeDurum && remaining <= 4) return 2
  if (yenilemeDurum === 'Yenileyecek' && remaining <= 4) return 3
  return 4
}

export function urgencyOf(remaining) {
  if (remaining === undefined || remaining === null) return 'ok'
  if (remaining <= 0) return 'finished'
  if (remaining <= 1) return 'urgent'
  if (remaining <= 2) return 'warning'
  return 'ok'
}

export function initials(fullName) {
  if (!fullName) return '?'
  return fullName.split(' ').map(function (s) { return s[0]; }).join('').toUpperCase().substring(0, 2)
}

export function pad(n) {
  return n.toString().padStart(2, '0')
}

export function getWeekStartMonday() {
  var d = new Date()
  var day = d.getDay()
  var diff = d.getDate() - day + (day === 0 ? -6 : 1)
  d.setDate(diff)
  d.setHours(0, 0, 0, 0)
  return d
}

export var DAY_NAMES = ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar']

// U4: secili sube sekme/sayfa gecisleri arasinda kaybolmasin (Dashboard her mount'ta
// SubeListesi'nin ilkine donuyordu). sessionStorage - sekme kapaninca sifirlanmasi dogru,
// farkli sekmede farkli sube secili olabilmeli (localStorage TUM sekmeleri etkiler).
var SUBE_GUID_KEY = 'studio_sube_guid'

export function subeGuidKaydet(guid) {
  if (guid) sessionStorage.setItem(SUBE_GUID_KEY, guid)
}

export function subeGuidOku() {
  return sessionStorage.getItem(SUBE_GUID_KEY) || ''
}

// Sube secimi oncelik sirasi: acik link (route query) > hatirlanan (sessionStorage) > listenin
// ilki - ikisi de listede artik yoksa (sube pasife alinmis/silinmis) sessizce atlanir.
export function subeGuidSec(subeListesi, routeQueryGuid) {
  var liste = subeListesi || []
  var varMi = function (g) { return !!g && liste.some(function (s) { return s.SubeGuid === g }) }
  if (varMi(routeQueryGuid)) return routeQueryGuid
  var hatirlanan = subeGuidOku()
  if (varMi(hatirlanan)) return hatirlanan
  return liste[0] ? liste[0].SubeGuid : null
}

// $Servis validateStatus:()=>true dondugu icin 400/999 de .then() ile gelir - cagiran ekranlar
// yalniz res.status===200'u kontrol edip 400/999'da SESSIZCE hicbir sey yapmiyordu (ST-U/U1).
// Studio ekranlarinin ortak 999 (is kurali uyarisi) / 400 (hata) toast'i tek yerde.
export function studioHataGoster($toast, res, hataMesaji) {
  if (res.status === 999) {
    $toast.add({ severity: 'warn', summary: 'Uyarı', detail: res.data, life: 5000 })
  } else if (res.status !== 401 && res.status !== 403 && !(res.status >= 200 && res.status < 300)) {
    // SDB1: 404/500/ağ hatası da sessiz kalmasın (401/403'ü $Servis kendisi yönetir)
    $toast.add({ severity: 'error', summary: 'Hata', detail: hataMesaji, life: 5000 })
  }
}

// --- Ders tipi renkleri ---------------------------------------------------
// Ders Tipi kaydinda dort ayri renk kolonu var (ArkaPlan/Cerceve/Yazi/Nokta) ve
// ayarlar ekraninda dordu de tek tek seciliyordu. Kontrast korumasi olmadigi icin
// soluk pastel secimler beyaz zeminde okunmuyor, chip'ler "pasif" gorunuyordu.
// Artik tek taban renk seciliyor, digerleri buradan turetiliyor.

export var DERS_TIP_RENKLERI = [
  { ad: 'Mor', renk: '#8B5CF6' },
  { ad: 'Mavi', renk: '#3B82F6' },
  { ad: 'Turkuaz', renk: '#06B6D4' },
  { ad: 'Yeşil', renk: '#22C55E' },
  { ad: 'Turuncu', renk: '#F97316' },
  { ad: 'Kırmızı', renk: '#EF4444' },
  { ad: 'Pembe', renk: '#EC4899' },
  { ad: 'Lacivert', renk: '#1E293B' }
]

// PrimeVue ColorPicker '#' olmadan deger doner; her yerde basina ekliyoruz.
export function hexNormalle(renk) {
  if (!renk) return ''
  var s = String(renk).trim()
  return s.charAt(0) === '#' ? s : '#' + s
}

function rgbCoz(renk) {
  var s = hexNormalle(renk).slice(1)
  if (s.length === 3) s = s[0] + s[0] + s[1] + s[1] + s[2] + s[2]
  if (s.length !== 6) return null
  var n = parseInt(s, 16)
  if (isNaN(n)) return null
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 }
}

function hexYaz(rgb) {
  var p = function (v) {
    var s = Math.max(0, Math.min(255, Math.round(v))).toString(16)
    return s.length === 1 ? '0' + s : s
  }
  return '#' + p(rgb.r) + p(rgb.g) + p(rgb.b)
}

function kanalIsik(v) {
  var c = v / 255
  return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)
}

// WCAG bagil parlaklik: 0 = siyah, 1 = beyaz
export function parlaklik(renk) {
  var rgb = rgbCoz(renk)
  if (!rgb) return 1
  return 0.2126 * kanalIsik(rgb.r) + 0.7152 * kanalIsik(rgb.g) + 0.0722 * kanalIsik(rgb.b)
}

// WCAG kontrast orani: 1 = ayni renk, 21 = siyah/beyaz
export function kontrastOrani(a, b) {
  var la = parlaklik(a)
  var lb = parlaklik(b)
  return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05)
}

// Verilen zemin uzerinde okunabilir yazi rengi (beyaz ya da koyu lacivert)
export function okunabilirYazi(zemin) {
  return kontrastOrani(zemin, '#ffffff') >= 3 ? '#ffffff' : '#1e293b'
}

export function koyulastir(renk, oran) {
  var rgb = rgbCoz(renk)
  if (!rgb) return hexNormalle(renk)
  var k = 1 - (oran || 0.15)
  return hexYaz({ r: rgb.r * k, g: rgb.g * k, b: rgb.b * k })
}

// Beyaz zeminde okunur hale gelene kadar koyulastirir. Kayitli renk zaten
// yeterince koyuysa oldugu gibi doner; eski soluk kayitlar da bu sayede
// veritabanina dokunmadan okunur gorunuyor.
export function beyazdaOkunurRenk(renk) {
  var c = hexNormalle(renk)
  if (!rgbCoz(c)) return '#1e293b'
  var guvenlik = 0
  while (kontrastOrani(c, '#ffffff') < 4.5 && guvenlik < 12) {
    c = koyulastir(c, 0.15)
    guvenlik++
  }
  return c
}

// Tek taban renkten ders tipi kaydinin dort renk kolonunu turetir.
export function dersTipRenkleri(taban) {
  var bg = hexNormalle(taban) || '#8B5CF6'
  return {
    ArkaPlanRenk: bg,
    CerceveRenk: beyazdaOkunurRenk(bg),
    YaziRenk: okunabilirYazi(bg),
    NoktaRenk: bg
  }
}

// Takvim kartlarinin gun eslestirmesi icin YYYY-MM-DD anahtari.
// Gorunumler kartlari haftanin gunu indeksiyle (0-6) eslestirirken, Dashboard
// tek haftadan genis bir pencere (17 gun) cekiyordu; ayni haftanin gunune denk
// gelen komsu hafta dersleri de ayni sutuna dusuyor, ders iki kez gorunuyordu.
// Eslestirme artik gercek tarih uzerinden yapiliyor.
// SKD-9: ekranda gösterilen tarih gg.aa.yyyy. BE "2026-09-29" / "2026-09-29T00:00:00" döner;
// yyyy-aa-gg kısmı doğrudan okunur (saat dilimi kaymasın), diğerleri Date ile.
export function trTarih(d) {
  if (!d) return ''
  var m = typeof d === 'string' && d.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (m) return m[3] + '.' + m[2] + '.' + m[1]
  var t = (d instanceof Date) ? d : new Date(d)
  if (isNaN(t.getTime())) return String(d)
  return pad(t.getDate()) + '.' + pad(t.getMonth() + 1) + '.' + t.getFullYear()
}

export function tarihAnahtari(d) {
  if (!d) return ''
  var t = (d instanceof Date) ? d : new Date(d)
  if (isNaN(t.getTime())) return ''
  return t.getFullYear() + '-' + pad(t.getMonth() + 1) + '-' + pad(t.getDate())
}
